export default "__VITE_ASSET__DdUUERe3__"